import { TenantEntitySchema } from '@/entities/Entity'
import { TenantPermissionsSchema, TenantRestrictionsSchema } from '@/entities/TenantAccess'
import { LanguageSchema } from '@/entities/common'
import { z } from '@/utils/zod'

export const ApiKeySchema = TenantEntitySchema.extend({
    description: z.string().min(1).max(100),
    identificator: z.string().length(16),
    hash: z.string(),
    language: LanguageSchema,
    permissions: TenantPermissionsSchema,
    restrictions: TenantRestrictionsSchema,
    lastSeenAt: z.isoDateTime.nullable(),
})

export type ApiKey = z.infer<typeof ApiKeySchema>
